import * as React from 'react';
import { Radio } from 'semantic-ui-react';
import enhance from './enhance';

function FieldRadioBid(props) {
  const { meta } = props;

  return (
    <div className="field-group radio">
      <Radio
        label={props.displayLabel}
        onChange={props.changeToggle}
        checked={props.input.value === props.label}
        className={props.className}
        name={props.input.name}
      />
      {meta.touched && meta.error && (
        <div className="redux_form error">{meta.error}</div>
      )}
    </div>
  );
}

export default enhance((props) => <FieldRadioBid {...props} />);
